/*
Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CCLibraryIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'CCLibrary',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden="${hidden ? 'true' : 'false'}"
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 6h-3V3a1 1 0 00-1-1H3a1 1 0 00-1 1v26a1 1 0 001 1h3v3a1 1 0 001 1h26a1 1 0 001-1V7a1 1 0 00-1-1zM4 28V4h24v2H7a1 1 0 00-1 1v21zm28 4H8V8h14v14l4-3 4 3V8h2z"
    />
  </svg>`;
};
